export default __webpack_public_path__ + "ocr/tesseract-core.wasm-e4db7f953ac7bcf9f67bd39031e42241.js";